<template>
  <form
    @submit.prevent="submitType"
    class="form-template"
  >
    <b-field
      :label="inputDataLabel"
      :type="{'is-danger': errors.has('register')}"
      :message="errors.first('register')"
    >
      <b-input
        :value="value"
        @input="$emit('input', $event)"
        :name="inputDataLabel"
        v-validate="'required'"
        :data-vv-as="$t('fields_validator.register')"
        :maxlength="maxlength"
        :has-counter="false"
      />
    </b-field>
    <div class="link-reset" v-if="linkRegisterRecovery">
      <router-link tag="a" :to="{ name: 'RecuperarRegistro'}">
        {{ $t("login.recovery_register") }}
      </router-link>
    </div>
    <button :disabled="disabledButton" class="button button-primary" type="submit">
      {{ $t("login.confirm_button") }}
    </button>
  </form>
</template>

<script>
export default {
  name: 'FormRecovery',
  props: {
    value: {
      type: String,
      default: ''
    },
    inputDataLabel: {
      type: String,
      default: ''
    },
    linkRegisterRecovery: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String,
      default: '6'
    },
    disabledButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    submitType () {
      this.$emit('submitForm')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/stylesheets/base";
  .button[type=submit]{
    display: block;
    max-width: 100%;
    margin-top: 0;
    text-align: center;
  }
  .link-reset{
    margin-bottom: 1.8rem;
  }
</style>
